import React from "react";
import Header from "../components/Header";
import contact from "../components/images/contact-us.jpg";

function Contact() {
  const address = [
    {
      officeType: "Corporate Address",
      offices: [
        {
          country: "India",
          address:
            "MIG Block No. 89, Phase-III, Jntu Hitech city Road, Kphb, Hyderabad - 500072 Telangana India",
          email: "sales@sgmrpharma.com",
          email1: "purchase@sgmrpharma.com  ",
          phone: "+9140-23061889",
          phone1: "+91-9032001889",
        },
      ],
    },
    //         {
    //     "officeType": "R&D Center",
    //     "offices": [
    //         {
    //             "country": "India",
    //             "address": "Phase 5, Plot no 51, Navodaya industrial estate, IDA Cherlapally, Hyderabad, Telangana-500051",
    //             "email": "",
    //             "phone": "040-23061889"
    //         }
    //     ]
    // },
    // {
    //   offices: [
    //     {
    //       country: "UAE",
    //       address:
    //         "Capital Golden Tower - Office 906, Business Bay - Dubai United Arab Emirates",
    //       // "email": "sales@gmrpharma.com, purchase@gmrpharma.com",
    //       phone: "+971585396686",
    //       phone1: "+971585631889 ",
    //     },
    //   ],
    // },
    // {
    //   officeType: "",
    //   offices: [
    //     {
    //       country: "UK",
    //       address:
    //         "Appt. 615 Jefferson Place 1 Fernie Street, Manchester, United Kingdom, M4 4BL",
    //       // "email": "sales@gmrpharma.com",
    //       phone: "",
    //     },
    //   ],
    // },
  ];

  return (
    <div>
      <Header
        bkgImage={contact}
        title="Contact Us"
        subtitle="Join SGMR and enhance your career possiblities"
      />
      <div class="form-contact">
        <ul>
          <li>
            <form>
              <h3>Get in Touch With Us</h3>
              <input className="input" placeholder="Name" />
              <input className="input" placeholder="Email" type="email" />
              <input className="input" placeholder="Phone" type="phone" />
              <textarea
                className="input"
                placeholder="Message"
                rows="5"
                col="10"
              ></textarea>

              <button type="submit" className="form-btn">
                Submit
              </button>
            </form>
          </li>
          <li>
            <div className="map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.303318525387!2d78.40199907503715!3d17.49302838341234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91954b00cb9d%3A0xd483a077c38fcba3!2sSGMR%20Pharmaceuticals%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1727245236810!5m2!1sen!2sin"
                style={{ border: "0" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </li>
        </ul>
      </div>
      <div className="address">
        <h3>Our Offices</h3>
        <ul>
          {address.map((addre) => {
            return (
              <li>
                <div className="address-card">
                  <h4>
                    <span className="address-icon">
                      <img
                        style={{ height: "25px", width: "25px" }}
                        src="https://cdn-icons-png.flaticon.com/128/854/854901.png"
                      />
                    </span>
                    {addre.officeType}
                  </h4>
                  <ul>
                    {addre.offices.map((off) => {
                      return (
                        <li>
                          <h5 className="country">{off.country}</h5>
                          <p className="address">{off.address}</p>
                          {off.email && (
                            <p className="email">
                              <a href={`mailto:${off.email}`}>{off.email}</a>
                            </p>
                          )}

                          {off.email1 && (
                            <p className="email">
                              <a href={`mailto:${off.email1}`}>{off.email1}</a>
                            </p>
                          )}

                          {off.phone && (
                            <p className="phone">
                              <a href={`tel:${off.phone}`}>{off.phone}</a>
                            </p>
                          )}

                          {off.phone1 && (
                            <p className="phone">
                              <a href={`tel:${off.phone1}`}>{off.phone1}</a>
                            </p>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default Contact;
